import {
  SET_CENTRO_CUSTO,
  SET_EMPRESA,
  SET_FORNECEDOR,
  SET_GRUPO,
  SET_PRODUTO,
  SET_PROJETO,
  SET_RESPONSAVEL,
  SET_SOLICITANTE,
  SET_TIPO_PRODUTO,
} from './mutations.type';

export default {
  [SET_EMPRESA](state, empresa) {
    state.empresa = empresa;
  },
  [SET_CENTRO_CUSTO](state, centroCusto) {
    state.centroCusto = centroCusto;
  },
  [SET_PRODUTO](state, produto) {
    state.produto = produto;
  },
  [SET_PROJETO](state, projeto) {
    state.projeto = projeto;
  },
  [SET_RESPONSAVEL](state, responsavel) {
    state.responsavel = responsavel;
  },
  [SET_GRUPO](state, grupo) {
    state.grupo = grupo;
  },
  [SET_FORNECEDOR](state, fornecedor) {
    state.fornecedor = fornecedor;
  },
  [SET_SOLICITANTE](state, solicitante) {
    state.solicitante = solicitante;
  },
  [SET_TIPO_PRODUTO](state, tipoProduto) {
    state.tipoProduto = tipoProduto;
  },
};
